import { defineComponent as _defineComponent } from 'vue'
import {onMounted, reactive, getCurrentInstance, computed} from "vue";
import VueI18n from "vue-i18n";
import {WebFormModel} from "capitalist-shared/src/core/model";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import ArrowRightChevron from "@/views/pages/finance/accounts/banners/ArrowRightChevron.vue";
import ArrowLeftChevron from "@/views/pages/finance/accounts/banners/ArrowLeftChevron.vue";
import moment from "moment-timezone";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountsPageBannersSlider',
  setup(__props) {

class Banner {
  visible = false
  visible_en = false
  visible_ru = false
  startdate = 0
  deadline = 0
}

function shuffle(array: any[]) {
  let currentIndex = array.length,
      temporaryValue,
      randomIndex

  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }

  return array
}

class BannersModel extends WebFormModel {

  loadingStatus = new RemoteRequestState()

  banners: Banner[] = []

  loadBanners() {
    this.loadingStatus.loadStart()
    return httpAxiosApi.get('/webapi/finance/accounts/banners')
      .then((response) => {
        this.banners = shuffle([...response.data].map((banner) => {
          return Object.assign(new Banner(), {...banner});
        }))
        this.loadingStatus.loadEnd()
        return this.banners
      }, (error) => {
        this.checkAxiosError(error)
        this.loadingStatus.loadError()
        throw error
      })
  }
}

const model = reactive(new BannersModel())

const singleBanner = computed(() => {
  if (!hasBanners.value || visibleBanners.value.length !== 1) return null;
  return visibleBanners.value[0];
})

onMounted(() => {
  model.loadBanners()
})
// onReady(() => {
// const swiper = new Swiper('.swiper-container', {
//   // Optional parameters
//   direction: 'horizontal',
//   loop: true,
//   autoplay: {
//     delay: 5000,
//   },
//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//   },
// });
// })

const hasBanners = computed(() => {
  return model.loadingStatus.isLoaded && visibleBanners.value.length > 0
})

const visibleBanners = computed(() => {
  return model.banners.filter((banner) => {
    const s = moment.unix(banner.startdate);
    const e = moment.unix(banner.deadline);
    const visibleKey = 'visible_' + locale.value;
    return banner.visible && banner[visibleKey] && moment().isBetween(s, e);
  })
      .slice(0, 10); // показываем максимум 10 баннеров (5 пар)
})

const infiniteBannerPairs = computed(() => {
  if (visibleBanners.value.length < 2) return [];

  const pairs = []
  for (let i = 0; i < visibleBanners.value.length; i+=2) {
    pairs.push([visibleBanners.value[i], visibleBanners.value[(i + 1) % visibleBanners.value.length]])
  }

  return pairs;
})

const getBulletClass = ({ active, slideIndex, index }) => {
  return {
    'banners-slider--indicator': true,
    'banners-slider--indicator-active': active,
  };
};

const locale = computed(() => {
  const i18n = getCurrentInstance()?.proxy.$i18n as VueI18n;
  return i18n ? i18n.locale : 'ru';
})

const fallbackLocale = computed(() => {
  return locale.value == 'ru' ? 'en' : 'ru';
})

const imgUrlWide = (banner) => {
  return banner.banners['image_url_wide_' + locale.value]
    || banner.banners['image_url_wide_' + fallbackLocale.value]
}
const imgUrlMedium = (banner) => {
  return banner.banners['image_url_medium_' + locale.value]
    || banner.banners['image_url_medium_' + fallbackLocale.value]
}
const getUrl = (banner) => {
  return ((locale.value == 'en' && banner.urlEn) || !banner.url) ? banner.urlEn : banner.url;
}

return { __sfc: true,Banner, shuffle, BannersModel, model, singleBanner, hasBanners, visibleBanners, infiniteBannerPairs, getBulletClass, locale, fallbackLocale, imgUrlWide, imgUrlMedium, getUrl, VueperSlides, VueperSlide, ArrowRightChevron, ArrowLeftChevron }
}

})